import { Stack, Typography, useTheme, ClickAwayListener } from "@mui/material";
import { useEditSummariesMutation } from "api/api-compliance"; // Your API hook
import { Formik } from "formik";
import { MapContext } from "pages/maps/map";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import QuillEditor from "components/Common/Quill";

import "quill/dist/quill.snow.css";
import "./index.css";
import "./table-style.css"; // Import custom styles for table borders

const Summary = ({
  title,
  subject,
  data,
  readonly = true,
}: {
  title: string;
  subject: string;
  data: string;
  readonly?: boolean;
}) => {
  const mapName = useContext(MapContext);
  const [editSummaries] = useEditSummariesMutation();
  const [currentValue, setCurrentValue] = useState(data);
  const [editing, setEditing] = useState(false);

  const handleSave = async (value: string) => {
    if (mapName && currentValue !== value) {
      try {
        await editSummaries({
          map_name: mapName,
          data: { summary: value, subject },
        }).unwrap();
        setCurrentValue(value);
        toast.success("Summary Updated");
      } catch (err: any) {
        toast.error(`Error: ${err?.message || err}`);
      }
    }
  };

  return (
    <Formik
      initialValues={{ summary: data }}
      onSubmit={(values) => {
        handleSave(values.summary);
      }}
      enableReinitialize
    >
      {(formikProps) => {
        const { values, setFieldValue, handleSubmit } = formikProps;
        const theme = useTheme();

        const inputModeStyles = {
          p: 2,
          bgcolor: theme.palette.primary.main,
          borderRadius: 1,
          color: theme.palette.background.default,
        };

        return (
          <Stack spacing={1}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1em",
                ...(!readonly ? inputModeStyles : {}),
              }}
            >
              {title}
            </Typography>
            <ClickAwayListener
              onClickAway={() => {
                if (editing) {
                  setEditing(false);
                  if (values.summary !== currentValue) {
                    handleSubmit();
                  }
                }
              }}
            >
              <div>
                {readonly || !editing ? (
                  <div
                    className="ql-editor custom-readonly-table"
                    // style={{
                    //   minHeight: "100px",
                    //   border: "1px solid #eee",
                    //   borderRadius: 4,
                    //   padding: 8,
                    //   background: "#fafbfc",
                    //   cursor: readonly ? "not-allowed" : "pointer",
                    //   overflowX: "auto",
                    // }}
                    onClick={() => {
                      if (!readonly) setEditing(true);
                    }}
                    tabIndex={readonly ? -1 : 0}
                    role="button"
                    aria-label="Edit summary"
                    onKeyDown={(e) => {
                      if (!readonly && (e.key === "Enter" || e.key === " ")) {
                        setEditing(true);
                      }
                    }}
                    dangerouslySetInnerHTML={{
                      __html: values.summary || "<span style='color:#aaa'>Not described</span>",
                    }}
                  />
                ) : (
                  <QuillEditor
                    value={values.summary}
                    onChange={(val) => setFieldValue("summary", val)}
                    placeholder="Enter summary..."
                  />
                )}
              </div>
            </ClickAwayListener>
          </Stack>
        );
      }}
    </Formik>
  );
};

export default Summary;
